import { render, staticRenderFns } from "./CarrinhoView.vue?vue&type=template&id=3efc025e&scoped=true&"
import script from "./CarrinhoView.vue?vue&type=script&lang=js&"
export * from "./CarrinhoView.vue?vue&type=script&lang=js&"
import style0 from "./CarrinhoView.vue?vue&type=style&index=0&id=3efc025e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efc025e",
  null
  
)

export default component.exports